import React, { Component } from "react";
import { FormGroup, Label, Button, FormFeedback, Input, Row, Col } from "reactstrap";

import Form from "./../../../general/Form/Form";

import axios from "axios";

class CredentialForm extends Component {
  state = {
    invalidEmail: false
  };

  nameRef = React.createRef();
  emailRef = React.createRef();
  companyRef = React.createRef();
  passwordRef = React.createRef();

  onFormSubmitHandler = (e) => {
    e.preventDefault();
    let state = {
      invalidEmail: false
    };
    this.setState(state);

    let email = this.emailRef.value;

    if (email) {
      const config = {
        headers: {
          "Content-Type": "application/json"
        }, 
        withCredentials: true
      };
      const data = {
        name: this.nameRef.value,
        email: email,
        company: this.companyRef.value,
        password: this.passwordRef.value,
        userId: this.props.userId
      };
      axios
        .post(`${process.env.REACT_APP_API_HOST}/user/${this.props.userId}/credential`, data, config)
        .then((response) => {
          if (response.status === 200) {
            alert("A new credential was created");
            window.location.reload();
          }
        })
        .catch((error) => {
          alert("Problem creating credentials");
          console.log(error);
        });
    }
    if (!email) state.invalidEmail = true;
    this.setState({
      ...state
    });
  };

  render() {
    const style = {
      padding: "15px 50px"
    };

    return (
      <Form
        onSubmit={this.onFormSubmitHandler}
        colors={["#787ff6", "#7bd5f5"]}
        title="Create New Credentials"
        formStyle={style}
      >
        {/* <input type="hidden" value="this is required to turn off auto complete in chrome for some reason" /> */}
        <Row form className="mb-4">
          <Col xs={6} className="pl-5 pr-5">
            <FormGroup>
              <Label for="credentialName">Name</Label>
              <Input
                autoComplete="new-password"
                type="text"
                name="name"
                id="credentialName"
                placeholder="Credential's name"
                innerRef={(el) => (this.nameRef = el)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="credentialEmail">Email</Label>
              <Input
                autoComplete="new-password"
                type="email"
                name="email"
                id="credentialEmail"
                placeholder="Credential's email"
                invalid={this.state.invalidEmail}
                innerRef={(el) => (this.emailRef = el)}
              />
              <FormFeedback>Credential must have an email.</FormFeedback>
            </FormGroup>
          </Col>
          <Col xs={6} className="pl-5 pr-5">
            <FormGroup>
              <Label for="credentialCompany">Company</Label>
              <Input
                type="text"
                name="company"
                id="credentialCompany"
                placeholder="Credential's company"
                innerRef={(el) => (this.companyRef = el)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="credentialDefaultPassword">Default Password</Label>
              <Input
                type="text"
                name="defaultPassword"
                id="credentialDefaultPassword"
                placeholder="Set a default password"
                innerRef={(el) => (this.passwordRef = el)}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row form className="mb-4">
          <Col xs={6} className="pl-5 pr-5">
            <Button color="success">Create Credentials</Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default CredentialForm;
